
import { useState } from 'react';
import { type MarketAction, type Brand } from '@/utils/types';

export function useInventoryNavigation() {
  const [activeTab, setActiveTab] = useState<MarketAction>('consume');
  const [viewingTransactions, setViewingTransactions] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);
  
  const handleTabChange = (value: MarketAction) => {
    console.log("Changing tab to:", value);
    setActiveTab(value);
    return { activeTab: value };
  };
  
  const viewBrandTransactions = (brand: Brand) => {
    setViewingTransactions(true);
    return brand;
  };
  
  const handleBackFromTransactions = () => {
    setViewingTransactions(false);
  };
  
  const handleShowQRCode = () => {
    console.log("QR CODE TRIGGER: Showing QR Code");
    setShowQRCode(true);
  };
  
  const handleCancelQRCode = () => {
    setShowQRCode(false);
  };
  
  return {
    activeTab,
    viewingTransactions,
    showQRCode,
    setViewingTransactions,
    handleTabChange,
    viewBrandTransactions,
    handleBackFromTransactions,
    handleShowQRCode,
    handleCancelQRCode,
    setShowQRCode,
  };
}
